var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[(_vm.isLoading)?_c('error-loading'):_c('div',[_c('error-data')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }